import axios from 'axios';
import React, { useEffect, useState } from 'react';
import baseURL from '../../config';
import { useParams } from 'react-router-dom';

const ExecutiveTable = () => {
  const [executive, setExecutive] = useState([]);
  const { id } = useParams();

  const fetchExecutiveDetails = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/ExecutiveDetailById/${id}`);
      setExecutive(response.data.data); // Ensure data is in an array format
      
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  useEffect(() => {
    fetchExecutiveDetails();
  }, []);

  return (
    <>
      <div>
        <table>
          <thead>
            <tr>
              <th>Executive Name</th>
              <th>Email</th>
              <th>Phone No.</th>
            </tr>
          </thead>
          <tbody>
            {executive.map((exec, index) => (
              <tr key={index}>
                <td>{exec.name}</td>
                <td>{exec.email}</td>
                <td>{exec.phoneNumber}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ExecutiveTable;
